import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export default function ResidenceStep({ form, updateForm }) {
    const el = React.createElement;
    const u = (f, v) => updateForm({ [f]: v });
    
    return el('div', { className: 'space-y-6' },
        // Street Address
        el('div', { className: 'space-y-2' },
            el(Label, null, 'Street Address'),
            el(Input, { 
                value: form.address || '', 
                onChange: e => u('address', e.target.value), 
                className: 'rounded-none',
                'data-testid': 'street-address-input'
            })
        ),
        
        // City / State / ZIP
        el('div', { className: 'grid grid-cols-2 md:grid-cols-4 gap-4' },
            el('div', { className: 'space-y-2 col-span-2' },
                el(Label, null, 'City'),
                el(Input, { 
                    value: form.city || '', 
                    onChange: e => u('city', e.target.value), 
                    className: 'rounded-none',
                    'data-testid': 'city-input'
                })
            ),
            el('div', { className: 'space-y-2' },
                el(Label, null, 'State'),
                el(Input, { 
                    value: form.state || '', 
                    onChange: e => u('state', e.target.value), 
                    className: 'rounded-none', 
                    maxLength: 2,
                    placeholder: 'VA',
                    'data-testid': 'state-input'
                })
            ),
            el('div', { className: 'space-y-2' },
                el(Label, null, 'ZIP'),
                el(Input, { 
                    value: form.zip_code || '', 
                    onChange: e => u('zip_code', e.target.value), 
                    className: 'rounded-none',
                    'data-testid': 'zip-input'
                })
            )
        ),
        
        // County & Legal Residence
        el('div', { className: 'border-t border-stone-200 pt-6 mt-2' },
            el('h3', { className: 'font-medium text-sm text-muted-foreground mb-4' }, 'LEGAL RESIDENCE (for legal documents)'),
            el('div', { className: 'grid grid-cols-1 md:grid-cols-3 gap-4' },
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Resides In'),
                    el('select', { 
                        value: form.locality_type || 'county', 
                        onChange: e => u('locality_type', e.target.value),
                        className: 'w-full h-10 px-3 border border-input bg-background text-sm rounded-none focus:outline-none focus:ring-2 focus:ring-ring',
                        'data-testid': 'locality-type-select'
                    },
                        el('option', { value: 'county' }, 'County'),
                        el('option', { value: 'city' }, 'Independent City')
                    )
                ),
                el('div', { className: 'space-y-2 col-span-2' },
                    el(Label, null, form.locality_type === 'city' ? 'City Name' : 'County Name'),
                    el(Input, { 
                        value: form.locality_name || '', 
                        onChange: e => u('locality_name', e.target.value), 
                        className: 'rounded-none',
                        placeholder: form.locality_type === 'city' ? 'e.g., Richmond, Virginia Beach' : 'e.g., Fairfax, Henrico',
                        'data-testid': 'locality-name-input'
                    })
                )
            ),
            el('p', { className: 'text-xs text-muted-foreground mt-2' }, 
                'This determines how the residence appears in legal documents (e.g., "County of Fairfax" or "City of Richmond").'
            )
        ),
        
        // Driver's License Section
        el('div', { className: 'border-t border-stone-200 pt-6 mt-6' },
            el('h3', { className: 'font-medium text-sm text-muted-foreground mb-4' }, "DRIVER'S LICENSE"),
            el('div', { className: 'grid grid-cols-1 md:grid-cols-3 gap-4' },
                el('div', { className: 'space-y-2' },
                    el(Label, null, "License Number"),
                    el(Input, { 
                        value: form.drivers_license_number || '', 
                        onChange: e => u('drivers_license_number', e.target.value), 
                        className: 'rounded-none',
                        'data-testid': 'drivers-license-number-input'
                    })
                ),
                el('div', { className: 'space-y-2' },
                    el(Label, null, "License State"),
                    el(Input, { 
                        value: form.drivers_license_state || '', 
                        onChange: e => u('drivers_license_state', e.target.value), 
                        className: 'rounded-none', 
                        maxLength: 20,
                        placeholder: 'If different from residence',
                        'data-testid': 'drivers-license-state-input'
                    })
                ),
                el('div', { className: 'space-y-2' },
                    el(Label, null, "Expiration Date"),
                    el(Input, { 
                        type: 'date',
                        value: form.drivers_license_expiration || '', 
                        onChange: e => u('drivers_license_expiration', e.target.value), 
                        className: 'rounded-none',
                        'data-testid': 'drivers-license-expiration-input'
                    })
                )
            )
        )
    );
}
